import { type MaintenanceTemplateKind } from '@gb-ticket/shared-types';

export function templateKindLabel(kind: MaintenanceTemplateKind): string {
  switch (kind) {
    case 'structured':
    case 'pdf_overlay':
      return 'Eigene Checkliste';
    case 'pdf_ink':
      return 'Normales PDF';
    case 'pdf_acroform':
      return 'PDF mit Feldern';
  }
}

export function templateNeedsPdf(kind: MaintenanceTemplateKind): boolean {
  return kind !== 'structured';
}

/** One line when the PDF cannot be drawn yet. No second viewer beside it. */
export function templatePdfPreviewText(where: 'create' | 'version', uploaded: boolean): string {
  if (where === 'create') {
    return 'Die PDF erscheint hier, sobald sie auf der Versionsseite hochgeladen ist.';
  }
  if (!uploaded) {
    return 'Noch keine PDF hochgeladen.';
  }
  return 'Die PDF wird noch geprüft und kann danach angezeigt werden.';
}

export function templateChecklistDetail(kind: MaintenanceTemplateKind): string | null {
  if (kind === 'structured') {
    return 'ohne PDF';
  }
  if (kind === 'pdf_overlay') {
    return 'Felder auf PDF';
  }
  return null;
}
